import React from 'react'

import { AttachmentPreview } from 'components/AttachmentPreview'

import { useAttachmentPreviewController } from './hooks/useAttachmentPreviewController'

export const SpDeliveryWorkAttachmentPreviewPage: React.FC = () => {
  const { pageState, fileUrl, fileName, isPdf, isPreviewable } = useAttachmentPreviewController()

  return (
    <AttachmentPreview
      pageState={pageState}
      fileUrl={fileUrl}
      fileName={fileName}
      isPdf={isPdf}
      isPreviewable={isPreviewable}
    />
  )
}
